import { render, staticRenderFns } from "./PaymentHeader.vue?vue&type=template&id=a56a1406&scoped=true&"
import script from "./PaymentHeader.vue?vue&type=script&lang=js&"
export * from "./PaymentHeader.vue?vue&type=script&lang=js&"
import style0 from "./PaymentHeader.vue?vue&type=style&index=0&id=a56a1406&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56a1406",
  null
  
)

export default component.exports